import { WorkspaceConfiguration } from '@citrite/workspace-ui-platform';

export enum DetailedDesktopStatus {
	TileEnabled = 'true',
}

/**
 * Returns `true` when the workspace configuration's
 * `userInterface.detailedDesktop.tileEnabled` setting is the string `'true'`
 * (case-insensitive).
 *
 * Safely handles a missing `detailedDesktop` object as well as a missing or
 * `null` `tileEnabled` value — the optional chaining on `tileEnabled` is
 * required because the cloud can return `detailedDesktop: {}` or
 * `detailedDesktop: { tileEnabled: null }` (see WSUI-12431).
 *
 * Shared by `Workspace/utils.isDetailedDesktopTileEnabled` and
 * `DetailedDesktopAccessor.isDetailedDesktopTileEnabled` so the guard cannot
 * drift between the two call sites again.
 */
export function isDetailedDesktopTileSettingEnabled(
	workspaceConfiguration: WorkspaceConfiguration
): boolean {
	return (
		workspaceConfiguration?.userInterface?.detailedDesktop?.tileEnabled?.toLowerCase() ===
		DetailedDesktopStatus.TileEnabled
	);
}
